import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface DataVisibilityContextType {
  isVisible: boolean;
  toggleVisibility: () => void;
}

const DataVisibilityContext = createContext<DataVisibilityContextType | undefined>(undefined);

export const DataVisibilityProvider = ({ children }: { children: ReactNode }) => {
  const [isVisible, setIsVisible] = useState(() => {
    const saved = localStorage.getItem('data_visibility');
    return saved !== 'hidden';
  });

  useEffect(() => {
    localStorage.setItem('data_visibility', isVisible ? 'visible' : 'hidden');
  }, [isVisible]);

  const toggleVisibility = () => {
    setIsVisible(prev => !prev);
  };

  return (
    <DataVisibilityContext.Provider value={{ isVisible, toggleVisibility }}>
      {children}
    </DataVisibilityContext.Provider>
  );
};

export const useDataVisibility = () => {
  const context = useContext(DataVisibilityContext);
  if (context === undefined) {
    throw new Error('useDataVisibility must be used within a DataVisibilityProvider');
  }
  return context;
};
